import { render, staticRenderFns } from "./RuleGroup.vue?vue&type=template&id=fb51b330&scoped=true&"
import script from "./RuleGroup.vue?vue&type=script&lang=js&"
export * from "./RuleGroup.vue?vue&type=script&lang=js&"
import style0 from "./RuleGroup.vue?vue&type=style&index=0&id=fb51b330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb51b330",
  null
  
)

export default component.exports